module.exports = __webpack_public_path__ + "img/22.4441f3f1.png";